import { getClosestTableRow } from '@lib/popups';
import { PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import { StakeholderSelector } from '@ui/StakeholderSelector';
import { StakeholderType } from '@sonar-software/sonar-core';

import React, { useCallback } from 'react';
import { useApplicationReference, useUpdateDataSecurityApp } from '@hooks';

export interface AppGroupCellEditorProps {
	applicationId: number;
}

export const AppGroupCellEditor: React.FC<AppGroupCellEditorProps> = ({ applicationId }) => {
	const { request } = useUpdateDataSecurityApp();
	const { stakeholderGroupId } = useApplicationReference(applicationId);

	const handleOnChange = useCallback((value: number) => {
		if (stakeholderGroupId !== value) {
			request({
				applicationId,
				stakeholderGroupId: value ?? null
			});
		}
	}, [ applicationId, request, stakeholderGroupId ]);

	return (
		<StakeholderSelector
			getPopupContainer={ getClosestTableRow }
			isSpreadsheet
			onChange={ handleOnChange }
			placeholder={ PLACEHOLDERS_COPY.SELECT_APP_GROUP }
			stakeholderType={ StakeholderType.Team }
			value={ stakeholderGroupId } />
	);
};
